import { render, staticRenderFns } from "./CardMoreButton.vue?vue&type=template&id=837f88b8&scoped=true&"
import script from "./CardMoreButton.vue?vue&type=script&lang=ts&"
export * from "./CardMoreButton.vue?vue&type=script&lang=ts&"
import style0 from "./CardMoreButton.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./CardMoreButton.vue?vue&type=style&index=1&id=837f88b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837f88b8",
  null
  
)

export default component.exports